"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 3.0.32
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationResponseCodeToJSON = exports.VerificationResponseCodeFromJSONTyped = exports.VerificationResponseCodeFromJSON = exports.VerificationResponseCode = void 0;
/**
 * SAVE ONLY: Controls the level of access the User has to ISV responses.  * NON (No access) * USR (this user) * GRP (user\'s Group) * LOC (user\'s Department) * ORG (user\'s Agency)
 * @export
 * @enum {string}
 */
var VerificationResponseCode;
(function (VerificationResponseCode) {
    VerificationResponseCode["NON"] = "NON";
    VerificationResponseCode["USR"] = "USR";
    VerificationResponseCode["GRP"] = "GRP";
    VerificationResponseCode["LOC"] = "LOC";
    VerificationResponseCode["ORG"] = "ORG";
})(VerificationResponseCode = exports.VerificationResponseCode || (exports.VerificationResponseCode = {}));
function VerificationResponseCodeFromJSON(json) {
    return VerificationResponseCodeFromJSONTyped(json, false);
}
exports.VerificationResponseCodeFromJSON = VerificationResponseCodeFromJSON;
function VerificationResponseCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.VerificationResponseCodeFromJSONTyped = VerificationResponseCodeFromJSONTyped;
function VerificationResponseCodeToJSON(value) {
    return value;
}
exports.VerificationResponseCodeToJSON = VerificationResponseCodeToJSON;
